import ModalSettings from './modalSettings';

export default ModalSettings;
